/* Promo campaign price guard.
   Appstle (and other apps) rewrite spans with the `appstle_subscription_amount`
   class to the live non-promo price, clobbering the Liquid-rendered promo price.
   This watches each promo sale span and, whenever an external script writes a
   new value V into it, moves V to the struck-through original span and rewrites
   the sale span as V discounted by the campaign multiplier.
   Fails safe: with no promo markup on the page it does nothing. */
(function () {
  'use strict';

  function parseMoney(text) {
    var m = text.match(/^(.*?)(\d[\d,]*(?:\.\d{1,2})?)(.*)$/);
    if (!m) return null;
    return { prefix: m[1], value: parseFloat(m[2].replace(/,/g, '')), suffix: m[3] };
  }

  function format(prefix, value, suffix) {
    var s = value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return prefix + s + suffix;
  }

  function update(el, mult) {
    var txt = (el.textContent || '').trim();
    if (!txt || txt === el.getAttribute('data-promo-last')) return; // our own write or unchanged
    var p = parseMoney(txt);
    if (!p || !(p.value > 0)) return;
    var sale = Math.round(p.value * mult) / 100;
    var wrap = el.closest('.july2026-widget-price');
    if (wrap) {
      var orig = wrap.querySelector('.july2026-widget-price__original');
      if (orig) orig.textContent = format(p.prefix, p.value, p.suffix);
    }
    var out = format(p.prefix, sale, p.suffix);
    el.setAttribute('data-promo-last', out);
    el.textContent = out;
  }

  /* The banner renders as the first element inside the sticky .header-group,
     above the nav, so both stick together on every template. One special
     case: on the homepage the header is `position: fixed; top: 0`
     (transparent overlay on the hero) and would cover the banner — push it
     down by the banner height there. In-flow headers need nothing. */
  function initBanner() {
    var banner = document.querySelector('.july2026-banner');
    if (!banner) return;
    var group = document.querySelector('.header-group');
    var header = group ? group.querySelector('header') : null;
    if (!header) return;

    var queued = false;
    function place() {
      queued = false;
      var isFixed = getComputedStyle(header).position === 'fixed';
      header.style.top = isFixed ? banner.offsetHeight + 'px' : '';
    }
    function queue() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(place);
    }

    place();
    window.addEventListener('resize', queue);
    window.addEventListener('scroll', queue, { passive: true }); // banner height can change on wrap
  }

  /* Code gate: promo pricing renders in the HTML but stays hidden (CSS) until
     the visitor's Shopify `discount_code` cookie — set by /discount/CODE links
     and the banner's Apply button — matches the campaign code. Then we stamp
     `july2026-code-applied` on <html>, which flips .july2026-no-code /
     .july2026-when-code visibility, and mark the banner as applied. */
  function initCodeGate() {
    var source = document.querySelector('[data-promo-code]');
    var code = source ? (source.getAttribute('data-promo-code') || '').trim().toUpperCase() : '';
    if (!code) return;
    var m = document.cookie.match(/(?:^|;\s*)discount_code=([^;]+)/);
    var applied = m ? decodeURIComponent(m[1]).trim().toUpperCase() : '';
    if (applied !== code) return;
    document.documentElement.classList.add('july2026-code-applied');
    var banner = document.querySelector('.july2026-banner');
    if (banner) {
      banner.classList.add('july2026-banner--applied');
      var link = banner.querySelector('.july2026-banner__link');
      if (link) link.textContent = '✓ ' + code + ' applied';
    }
  }

  function init() {
    initCodeGate();
    initBanner();
    document.querySelectorAll('.july2026-widget-price__sale').forEach(function (el) {
      var wrap = el.closest('.july2026-widget-price');
      var mult = wrap ? parseFloat(wrap.getAttribute('data-promo-multiplier')) : NaN;
      if (!mult || mult <= 0 || mult >= 100) return;
      update(el, mult);
      new MutationObserver(function () {
        update(el, mult);
      }).observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
